export const SET_SYNC_USERNAME = "SET_SYNC_USERNAME";
export const SET_SYNC_PASSWORD = "SET_SYNC_PASSWORD";
export const SET_SYNC_HOTEL_ID = "SET_SYNC_HOTEL_ID";

export const AUTHENTICATE_SYNC_USER_REQUEST = "AUTHENTICATE_SYNC_USER_REQUEST";
export const AUTHENTICATE_SYNC_USER_SUCCESS = "AUTHENTICATE_SYNC_USER_SUCCESS";
export const AUTHENTICATE_SYNC_USER_REJECT = "AUTHENTICATE_SYNC_USER_REJECT";

export const SYNC_USER_REQUEST = "SYNC_USER_REQUEST";
export const SYNC_USER_SUCCESS = "SYNC_USER_SUCCESS";
export const SYNC_USER_REJECT = "SYNC_USER_REJECT";

export const SYNC_HOTEL_REQUEST = "SYNC_HOTEL_REQUEST";
export const SYNC_HOTEL_SUCCESS = "SYNC_HOTEL_SUCCESS";
export const SYNC_HOTEL_REJECT = "SYNC_HOTEL_REJECT";

export const SYNC_ROOM_GROUPS_REQUEST = "SYNC_ROOM_GROUPS_REQUEST";
export const SYNC_ROOM_GROUPS_SUCCESS = "SYNC_ROOM_GROUPS_SUCCESS";
export const SYNC_ROOM_GROUPS_REJECT = "SYNC_ROOM_GROUPS_REJECT";

export const SYNC_ROOMS_REQUEST = "SYNC_ROOMS_REQUEST";
export const SYNC_ROOMS_SUCCESS = "SYNC_ROOMS_SUCCESS";
export const SYNC_ROOMS_REJECT = "SYNC_ROOMS_REJECT";

export const GET_SYNC_USER_REQUEST = "GET_SYNC_USER_REQUEST";
export const GET_SYNC_USER_SUCCESS = "GET_SYNC_USER_SUCCESS";
export const GET_SYNC_USER_REJECT = "GET_SYNC_USER_REJECT";

export const STEP_CHANGE = "STEP_CHANGE";
export const CLEAR_STEPS = "CLEAR_STEPS";
export const SET_LOGIN = "SET_LOGIN";
export const SET_PASSWORD = "SET_PASSWORD";
export const SELECT_HOTEL = "SELECT_HOTEL";
export const SCHEDULE_GETTING_ROOM_INFO = "SCHEDULE_GETTING_ROOM_INFO";



// WEBPACK FOOTER //
// ./src/synchronization/constants.js